module.exports = __webpack_public_path__ + "static/img/img07.a40d769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv029/img07.png
// module id = n6Qs
// module chunks = 0